var host = "dev-kunyao.zhongkevip.cn"
let urls = window.location.href

if (urls.indexOf('localhost') != -1) {
  var host = "dev-kunyao.zhongkevip.cn"
} else if (urls.indexOf('dev-') == -1) {
  var host = "item.shandongkunyao.cn"
}
var domain="https://"+host
var config = {
  // 下面的地址配合云端 Server 工作
  host,
  domain,
  img_url:`${domain}/statics/admin/images/`,
  //验证码
  verifyCode_url: `${domain}/admin/Public/verifycode`,
  //登录
  login_url: `${domain}/admin/Public/login`,
  //添加栏目
  add_categoty_url: `${domain}/admin/Category/change`,
  //栏目列表
  load_categoty_url: `${domain}/admin/Category/load`,

  //上传图片创建文件夹
  changeFolder_url: `${domain}/admin/Assets/changeFolder`,
  //删除图片
  DelAssets_url: `${domain}/admin/Assets/DelAssets`,
  //更新图片
  ChangeFile_url: `${domain}/admin/Assets/ChangeFile`,
  //图片列表
  LoadData_url: `${domain}/admin/Assets/LoadData`,
  //上传图片
  uploadAsset_url: `${domain}/admin/Assets/uploadAsset`,

  //菜单列表
  menu_url: `${domain}/admin/Menu/load`,
  //菜单当前位置
  menu_position_url: `${domain}/admin/Menu/parents`,
  //模型列表
  moduleList_url:`${domain}/admin/Category/moduleList`,
  //栏目详情
  categotyDetail_url:`${domain}/admin/Category/detail`,
  //删除栏目
  deleteCategory_url:`${domain}/admin/Category/delete`,

  //cp首页
  IndexInfo_url: `${domain}/admin/RelatedSet/IndexInfo`,

  //新增组织架构
  changeJigou_url: `${domain}/admin/Jigou/changeJigou`,
  //组织架构列表
  JigouLoadData_url: `${domain}/admin/Jigou/LoadData`,
  //组织架构删除
  delJigou_url: `${domain}/admin/Jigou/delJigou`,
  //组织架构转移
  changeJigouPid_url: `${domain}/admin/Jigou/ChangeJigouPid`,

  //添加用户
  change_user_url: `${domain}/admin/User/change`,
  //修改密码
  changePwd_user_url: `${domain}/admin/User/ChangePwd`,
  //用户列表
  load_user_url: `${domain}/admin/User/loadList`,
  //用户详情
  userDetail_url:`${domain}/admin/User/detail`,
  //删除用户
  userDelete_url:`${domain}/admin/User/delete`,
  //角色列表
  userRole_url:`${domain}/admin/User/roleList`,
  //银行卡列表
  UserBankList:`${domain}/admin/UserBank/List`,
  //银行卡列表新增
  UserBankChange:`${domain}/admin/UserBank/Change`,
  //银行卡列表删除
  UserBankDel:`${domain}/admin/UserBank/Del`,


  //部门列表
  DaRenJiGouLoadList_url:`${domain}/admin/DaRenJiGou/LoadList`,
  //新增编辑部门
  DaRenJiGouChange_url:`${domain}/admin/DaRenJiGou/Change`,
  //新增编辑部门
  PublicCity_url:`${domain}/admin/Public/City`,
  //部门排序
  DaRenJiGouChangeJigouSort_url:`${domain}/admin/DaRenJiGou/ChangeJigouSort`,
  //删除部门
  DaRenJiGouDelJigou_url:`${domain}/admin/DaRenJiGou/DelJigou`,
  //移动位置
  DaRenJiGouChangeJigouPid_url:`${domain}/admin/DaRenJiGou/ChangeJigouPid`,

  //角色管理
  DaRenRoleLoadList_url:`${domain}/admin/DaRenRole/LoadList`,
  //删除角色
  DaRenRoleDel_url:`${domain}/admin/DaRenRole/Del`,
  //新增角色
  DaRenRoleChange_url:`${domain}/admin/DaRenRole/Change`,
  //角色详情
  DaRenRoleFind_url:`${domain}/admin/DaRenRole/Find`,
  //获取全部导航菜单
  DaRenRoleLoadMenu_url:`${domain}/admin/DaRenRole/LoadMenu`,
  //修改角色导航菜单
  DaRenRoleChangeRoleMenu_url:`${domain}/admin/DaRenRole/ChangeRoleMenu`,
  //获取全部权限
  DaRenRoleLoadPower_url:`${domain}/admin/DaRenRole/LoadPower`,
  //修改角色权限
  DaRenRoleChangeRolePower_url:`${domain}/admin/DaRenRole/ChangeRolePower`,

  //供应商列表
  supplierList_url:`${domain}/admin/Supplier/SupplierList`,
  //供应商添加
  supplierAdd_url:`${domain}/admin/Supplier/SupplierChange`,
  //供应商删除
  supplierDel_url:`${domain}/admin/Supplier/SupplierDelete`,
  //供应商详情
  supplierDetail_url:`${domain}/admin/Supplier/SupplierDetail`,


  //客户管理列表
  YxList_url:`${domain}/admin/RelatedSet/YxList`,
  //客户管理新增
  YxChange_url:`${domain}/admin/RelatedSet/YxChange`,
  //客户管理列表删除
  DelYx_url:`${domain}/admin/RelatedSet/DelYx`,
  //客户管理总包甲方新增
  YxMxChange_url:`${domain}/admin/RelatedSet/YxMxChange`,
  //客户管理总包甲方删除
  DelYxMx_url:`${domain}/admin/RelatedSet/DelYxMx`,
  //客户管理进度删除
  DelFollow_url:`${domain}/admin/RelatedSet/DelFollow`,

  //材料库列表
  CaiLiaoData_url:`${domain}/admin/Purchase/CaiLiaoData`,
  //材料库添加
  ChangeCl_url:`${domain}/admin/Purchase/ChangeCl`,
  //材料库删除
  DelCl_url:`${domain}/admin/Purchase/DelCl`,


//客户信息列表
  customerList_url:`${domain}/admin/Customer/CustomerList`,
  //客户添加
  customerAdd_url:`${domain}/admin/Customer/CustomerChange`,
  //客户删除
  customerDisable_url:`${domain}/admin/Customer/CustomerDisable`,
  //客户详情
  customerDetail_url:`${domain}/admin/Customer/CustomerDetail`,
  //跟进记录列表
  customerFollowList_url:`${domain}/admin/Customer/CustomerFollowList`,
  //添加跟进记录
  customerFollowAdd_url:`${domain}/admin/Customer/CustomerFollowAdd`,

  //报销类型列表
  BxTypeList_url:`${domain}/admin/RelatedSet/BxTypeList`,
  //报销类型新增/编辑
  BxTypeChange_url:`${domain}/admin/RelatedSet/BxTypeChange`,

  //客户分类
  YxTypeList_url:`${domain}/admin/RelatedSet/YxTypeList`,
  //客户分类新增/编辑
  YxTypeChange_url:`${domain}/admin/RelatedSet/YxTypeChange`,
  //客户分类删除
  DelYxType_url:`${domain}/admin/RelatedSet/DelYxType`,

  //审批删除
  DelSp_url:`${domain}/admin/RelatedSet/DelSp`,

  //费用支付审批列表
  ApprovalList:`${domain}/admin/Approval/List`,
  //费用支付管理新增/编辑
  ApprovalChange:`${domain}/admin/Approval/Change`,
  //费用支付管理详情
  ApprovalDetail:`${domain}/admin/Approval/Detail`,
  //费用支付删除
  ApprovalDel:`${domain}/admin/Approval/Del`,
  //类型列表
  TypeList:`${domain}/admin/Type/List`,
  //类型新增/编辑
  TypeChange:`${domain}/admin/Type/Change`,
  //类型删除
  TypeDel:`${domain}/admin/Type/Del`,
  //获取所有关联类型
  TypeGetAll:`${domain}/admin/Type/GetAll`,
  //获取所有关联类型
  GetTypeAll:`${domain}/admin/Approval/GetTypeAll`,
  //审核审批
  ApprovalShenHe:`${domain}/admin/Approval/ShenHe`,
  //印章借离确认归还
  ApprovalGuiHuan:`${domain}/admin/Approval/GuiHuan`,
  //用印审批确认盖章
  ApprovalConfirmSeals:`${domain}/admin/Approval/ConfirmSeals`,
  //获取对应模式的角色导航
  GetRoleMenu:`${domain}/admin/Menu/GetRoleMenu`,
  //工作计划新增
  WeekChangeItem:`${domain}/admin/Week/ChangeItem`,
  //工作计划列表
  WeekItemList:`${domain}/admin/Week/ItemList`,
  //工作计划列表删除
  WeekItemDel:`${domain}/admin/Week/ItemDel`,
  //工作计划明细新增
  WeekChangeItemMx:`${domain}/admin/Week/ChangeItemMx`,
  //工作计划明细列表
  WeekItemMx:`${domain}/admin/Week/ItemMx`,
  //工作计划明细列表删除
  WeekItemMxDel:`${domain}/admin/Week/ItemMxDel`,



  //报销审批列表
  BaoxiaoList_url:`${domain}/admin/RelatedSet/BxList`,
  //报销审批管理新增/编辑
  BaoxiaoChange_url:`${domain}/admin/RelatedSet/BxChange`,
  //报销审批支付
  PayBx_url:`${domain}/admin/RelatedSet/PayBx`,
  //报销审批作废
  VoidBx_url:`${domain}/admin/RelatedSet/VoidBx`,

  //印章类型列表
  SealTypeList_url:`${domain}/admin/RelatedSet/SealsTypeList`,
  //印章类型新增/编辑
  SealTypeChange_url:`${domain}/admin/RelatedSet/SealsTypeChange`,

  //用印审批列表
  SealsList_url:`${domain}/admin/RelatedSet/SealsList`,
  //用印审批新增/编辑
  SealsChange_url:`${domain}/admin/RelatedSet/SealsChange`,
  //用印审批确认
  ConfirmSeals_url:`${domain}/admin/RelatedSet/ConfirmSeals`,
  //用印审批作废
  VoidSeals_url:`${domain}/admin/RelatedSet/VoidSeals`,

  //立项审批列表
  LxsList_url:`${domain}/admin/RelatedSet/LxList`,
  //立项审批新增/编辑
  LxChange_url:`${domain}/admin/RelatedSet/LxChange`,
  //立项审批作废
  VoidLx_url:`${domain}/admin/RelatedSet/VoidLx`,
  //立项审批保存利润预算
  LxLr_url:`${domain}/admin/RelatedSet/LxLr`,
  //立项审批保存销售信息
  LxXsChange_url:`${domain}/admin/RelatedSet/LxXsChange`,
  //立项审批删除销售信息
  LxXsDel_url:`${domain}/admin/RelatedSet/LxXsDel`,
  //立项审批保存采购信息
  LxCgChange_url:`${domain}/admin/RelatedSet/LxCgChange`,
  //立项审批删除采购信息
  LxCgDel_url:`${domain}/admin/RelatedSet/LxCgDel`,

  //发票审批列表
  InvoiceSpList_url:`${domain}/admin/RelatedSet/InvoiceSpList`,
  //发票审批新增/编辑
  InvChange_url:`${domain}/admin/RelatedSet/InvChange`,
  //开具发票确认
  QrInvSp_url:`${domain}/admin/RelatedSet/QrInvSp`,
  //发票审批作废
  VoidInvSp_url:`${domain}/admin/RelatedSet/VoidInvSp`,

  //支付类型列表
  PayTypeList_url:`${domain}/admin/RelatedSet/PayTypeList`,
  //支付类型新增/编辑
  PayTypeChange_url:`${domain}/admin/RelatedSet/PayTypeChange`,

  //采购合同审批列表
  cgBuyList_url:`${domain}/admin/RelatedSet/BuyList`,
  //采购合同审批新增/编辑
  cgBuyChange_url:`${domain}/admin/RelatedSet/BuyChange`,
  //采购合同审批作废
  VoidCgBuy_url:`${domain}/admin/RelatedSet/VoidBuy`,

  //付款审批列表
  PayList_url:`${domain}/admin/RelatedSet/PayList`,
  //付款审批管理新增/编辑
  PayChange_url:`${domain}/admin/RelatedSet/PayChange`,
  //付款审批作废
  VoidPay_url:`${domain}/admin/RelatedSet/VoidPay`,

  // 报销审批确认支付新增
  PayBxAdd_url:`${domain}/admin/RelatedSet/PayBx`,
  // 报销审批确认支付删除
  DelZf_url:`${domain}/admin/RelatedSet/DelZf`,
  // 费用审批确认支付新增
  FeiYongCreate_url:`${domain}/admin/Approval/FeiYongCreate`,
  // 费用审批确认支付删除
  FeiYongDel_url:`${domain}/admin/Approval/FeiYongDel`,

  //付款审批确认支付
  QrPay_url:`${domain}/admin/RelatedSet/QrPay`,
  // 付款审批确认支付删除
  DelPay_url:`${domain}/admin/RelatedSet/DelPay`,
  //付款审批开票管理
  QrKp_url:`${domain}/admin/RelatedSet/QrKp`,
  // 付款审批开票管理删除
  DelPayKp_url:`${domain}/admin/RelatedSet/DelPayKp`,

  //行政审批列表
  XzList_url:`${domain}/admin/RelatedSet/XzList`,
  //行政审批管理新增/编辑
  XzChange_url:`${domain}/admin/RelatedSet/XzChange`,

  //项目列表拉去所有的
  projectList_url:`${domain}/admin/Project/List`,
  // 项目列表
  ProjietList_url:`${domain}/admin/RelatedSet/ProjietList`,
  // 项目列表新增
  ProjectChange_url:`${domain}/admin/RelatedSet/ProjectChange`,
  // 项目列表删除
  DelProjiet_url:`${domain}/admin/RelatedSet/DelProjiet`,
  //项目跟进记录
  ProjectFollow_url:`${domain}/admin/RelatedSet/ProjectFollow`,
  //项目跟进记录新增
  FollowChange_url:`${domain}/admin/RelatedSet/FollowChange`,

  //项目工作日志
  WorkLog_url:`${domain}/admin/RelatedSet/WorkLog`,
  //新增项目工作日志
  WorkLogChange_url:`${domain}/admin/RelatedSet/WorkLogChange`,
  //删除工作日志
  DelWorkLog_url:`${domain}/admin/RelatedSet/DelWorkLog`,
  //工作日志评论
  WorkLogPingLun_url:`${domain}/admin/RelatedSet/WorkLogPingLun`,
  //工作日志评论删除
  DelWorkPl_url:`${domain}/admin/RelatedSet/DelWorkPl`,

  //项目工作汇报蓝城
  GongZuoHuiBaoList:`${domain}/admin/GongZuoHuiBao/List`,
  //新增项目工作汇报
  GongZuoHuiBaoChange:`${domain}/admin/GongZuoHuiBao/Change`,
  //删除工作汇报
  GongZuoHuiBaoDel:`${domain}/admin/GongZuoHuiBao/Del`,
  //工作汇报详情
  GongZuoHuiBaoFind:`${domain}/admin/GongZuoHuiBao/Find`,

  //供货管理列表
  GhData_url:`${domain}/admin/Purchase/GhData`,
  //供货管理列表删除
  DelGh_url:`${domain}/admin/Purchase/DelGh`,
  //供货管理新增
  ChangeGh_url:`${domain}/admin/Purchase/ChangeGh`,
  //供货管理编辑
  UpGhMx_url:`${domain}/admin/Purchase/UpGhMx`,
  //供货管理确认验收
  ChangeYhMx_url:`${domain}/admin/Purchase/ChangeYhMx`,

  //验收管理列表
  YhData_url:`${domain}/admin/Purchase/YhData`,
  //验收管理列表删除
  DelYh_url:`${domain}/admin/Purchase/DelYh`,
  //验收管理新增
  ChangeYh_url:`${domain}/admin/Purchase/ChangeYh`,
  //验收管理编辑
  UpYhMx_url:`${domain}/admin/Purchase/UpYhMx`,

  //知识库分类列表
  LoadClass_url:`${domain}/admin/Knowledge/loadData`,
  //知识库分类新增编辑
  ChangeClass_url:`${domain}/admin/Knowledge/changeClass`,
  //知识库分类排序
  ChangeClassSort_url:`${domain}/admin/Knowledge/ChangeClassSort`,
  //知识库分类转移
  ChangeClassPid_url:`${domain}/admin/Knowledge/changeClassPid`,
  //知识库分类删除
  DelClass_url:`${domain}/admin/Knowledge/delClass`,

  //知识库文章
  LoadKnowData_url:`${domain}/admin/Knowledge/LoadKnowData`,
  //知识库文章新增编辑
  ChangeData_url:`${domain}/admin/Knowledge/Change`,
  //知识库文章删除
  DelData_url:`${domain}/admin/Knowledge/Del`,

  //立项审批列表
  LxList_url:`${domain}/admin/Project/LxList`,

  //审批管理
  SpList_url:`${domain}/admin/RelatedSet/SpList`,
  //审核通过
  QrSp_url:`${domain}/admin/RelatedSet/QrSp`,
  //审核驳回
  RejectSp_url:`${domain}/admin/RelatedSet/RejectSp`,

  //项目阶段列表
  StageList_url:`${domain}/admin/RelatedSet/StageList`,
  //项目阶段新增/编辑
  StageChange_url:`${domain}/admin/RelatedSet/StageChange`,
  //产品列表列表
  ProductList_url:`${domain}/admin/RelatedSet/ProductList`,
  //产品新增/编辑
  ProductChange_url:`${domain}/admin/RelatedSet/ProductChange`,
  //品牌列表列表
  BrandList_url:`${domain}/admin/RelatedSet/BrandList`,
  //品牌新增/编辑
  BrandChange_url:`${domain}/admin/RelatedSet/BrandChange`,
  //行政类型列表
  XzTypeList_url:`${domain}/admin/RelatedSet/XzTypeList`,
  //行政类型新增/编辑
  XzTypeChange_url:`${domain}/admin/RelatedSet/XzTypeChange`,
  //文件类别列表
  SealsFileTypeList_url:`${domain}/admin/RelatedSet/SealsFileTypeList`,
  //文件类别新增/编辑
  SealsFileTypeChange_url:`${domain}/admin/RelatedSet/SealsFileTypeChange`,


  // 合同修改
  ContractChange_url:`${domain}/admin/Contract/ContractChange`,
  //合同列表
  ContractList_url:`${domain}/admin/Contract/ContractList`,
  //合同作废
  ContractCancel_url:`${domain}/admin/Contract/ContractCancel`,
  //合同删除
  DelContract_url:`${domain}/admin/Contract/DelContract`,

  //所有合同列表
  ContractData_url:`${domain}/admin/Contract/getConData`,

  //合同拉取客户
  CustomerSonList_url:`${domain}/admin/Customer/CustomerSonList`,
//合同拉取客户
  ContractDetail_url:`${domain}/admin/Contract/ContractDetail`,


  //发票类型列表
  InvoiceTypeList_url:`${domain}/admin/RelatedSet/InvoiceTypeList`,
  //发票类型新增
  InvoiceTypeChange_url:`${domain}/admin/RelatedSet/InvoiceTypeChange`,
  //票据列表
  InvoiceList_url:`${domain}/admin/RelatedSet/InvoiceList`,
  //票据新增
  InvoiceChange_url:`${domain}/admin/RelatedSet/InvoiceChange`,
  //票据作废
  VoidInv_url:`${domain}/admin/RelatedSet/VoidInv`,
  //票据删除
  DelInvoice_url:`${domain}/admin/RelatedSet/DelInvoice`,
  //票据详情
  InvDetail_url:`${domain}/admin/RelatedSet/InvDetail`,
  //票据明细新增编辑
  InvoiceMxChange_url:`${domain}/admin/RelatedSet/InvoiceMxChange`,
  //票据明细删除
  DelInvoiceMx_url:`${domain}/admin/RelatedSet/DelInvoiceMx`,

  // 进销存下载
  JxcCsv_url:`${domain}/admin/Jxc/JxcCsv`,
  // 进销存列表
  JxcList_url:`${domain}/admin/Jxc/List`,
  // 进销存添加
  JxcChange_url:`${domain}/admin/Jxc/Change`,
  // 进销存删除
  DeleteJcx_url:`${domain}/admin/Jxc/DeleteJcx`,
  // 进销存修改
  JxcChangeMx_url:`${domain}/admin/Jxc/ChangeMx`,
  // 进销存任务删除
  DeleteJcxGys_url:`${domain}/admin/Jxc/DeleteJcxGys`,
  // 进销存导入
  UploadCsv_url:`${domain}/admin/JxcKunYao/JxcCsv`,
  // 进销存明细列表
  JxcMxList_url:`${domain}/admin/Jxc/MxList`,
  // 进销存新增修改明细
  JxcChangeMxInfo_url:`${domain}/admin/Jxc/ChangeMxInfo`,
  // 进销存明细列表删除
  JxcDeleteMx_url:`${domain}/admin/Jxc/DeleteMx`,

  // 新进销存付款明细
  JxcNewCsv_Fkurl:`${domain}/admin/RelatedSet/PayList`,
  // 新进销存结算金额
  JxcNewCsv_Jsurl:`${domain}/admin/JxcKunYao/JsMx`,
  // 新进销存下载
  JxcNewCsv_url:`${domain}/admin/JxcKunYao/JxcCsv`,
  // 新进销存列表
  JxcNewList_url:`${domain}/admin/JxcKunYao/LoadList`,
  // 新进销存添加
  JxcNewChange_url:`${domain}/admin/JxcKunYao/Change`,
  // 新进销存删除
  DeleteJcxNew_url:`${domain}/admin/JxcKunYao/Del`,
  // 进销存修改
  JxcNewChangeMx_url:`${domain}/admin/JxcKunYao/Change`,
  // 新进销存任务删除
  DeleteJcxNewGys_url:`${domain}/admin/JxcNew/DeleteJcxGys`,
  // 新进销存导入
  UploadNewCsv_url:`${domain}/admin/JxcKunYao/Import`,
  // 新进销存明细列表
  JxcNewMxList_url:`${domain}/admin/JxcKunYao/MxLoadList`,
  // 新进销存新增修改明细
  JxcNewChangeMxInfo_url:`${domain}/admin/JxcNew/ChangeMxInfo`,
  // 新进销存明细列表删除
  JxcNewDeleteMx_url:`${domain}/admin/JxcKunYao/DelMx`,

  // 结算单列表
  JsList_url:`${domain}/admin/RelatedSet/JsList`,
  // 结算单列表删除
  DelJs_url:`${domain}/admin/RelatedSet/DelJs`,
  // 新增结算单
  JsChange_url:`${domain}/admin/RelatedSet/JsChange`,
  //  新增结算明细
  JsMxChange_url:`${domain}/admin/RelatedSet/JsMxChange`,
  //  删除结算明细
  DelJsMx_url:`${domain}/admin/RelatedSet/DelJsMx`,

  // 回款单列表
  HkList_url:`${domain}/admin/RelatedSet/HkList`,
  // 回款单列表删除
  DelHk_url:`${domain}/admin/RelatedSet/DelHk`,
  // 新增回款单
  HkChange_url:`${domain}/admin/RelatedSet/HkChange`,
  // 新增回款明细
  HkMxChange_url:`${domain}/admin/RelatedSet/HkMxChange`,
  // 删除回款明细
  DelHkMx_url:`${domain}/admin/RelatedSet/DelHkMx`,
  // 新增申请明细
  HkApplyChange_url:`${domain}/admin/RelatedSet/HkApplyChange`,
  // 删除申请明细
  DelHkApply_url:`${domain}/admin/RelatedSet/DelHkApply`,

  //获取基本设置
  companysFind_url:`${domain}/admin/Companys/Find`,
  //保存基本设置
  companysChange_url:`${domain}/admin/Companys/Change`,

  //前端文档
  MyDetail_url: `${domain}/admin/User/MyDetail`,
  Authorize_url: `${domain}/admin/Weixin/Authorize`,

  //退出
  loginOut_url: `${domain}/admin/Public/loginOut`,



};

module.exports = config



// WEBPACK FOOTER //
// ./src/base/config.js